import React, { Component } from "react";
import CustomButton from "../components/CustomButton";
import Tick from "../images/tick.svg";
import Cancel from "../images/cancel.svg";
import Password from "../images/password.svg";
import { Form } from "react-bootstrap";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import { BaseUrl, Authorization, isUser, LogoutFunction } from "../static.js";

const passRegex = new RegExp("^((?=.*[a-z])|(?=.*[A-Z]))(?=.*[0-9])");
const mobileRegex = RegExp(/09(0[0-9]|1[1-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saveLoading: false,
      FNameValue: "",
      MobileValue: "",
      UserNameValue: "",
      CPasswordValue: "",
      NPasswordValue: "",
      CNPasswordValue: "",
      passwordPage: false,
      changePasswordLoading: false,
      actionError: "",
      CPasswordErrorText: "",
      NPasswordErrorText: "",
      CNPasswordErrorText: "",
      buttonDisabled: false,
      loading: true,
    };

    this.textHandleChange = this.textHandleChange.bind(this);
    // this.validateMobile = this.validateMobile.bind(this);
  }

  componentDidMount() {
    let data = {};
    if (isUser) data = { businessCode: this.props.businessCode };
    // else data = {};
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "readPersonalInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result.result);
        if (result.status === 200) {
          this.setState({
            loading: false,
            FNameValue:
              result.result[0].fullName !== null
                ? result.result[0].fullName
                : "",
            MobileValue:
              result.result[0].mobile !== null ? result.result[0].mobile : "",
            UserNameValue: result.result[0].userName,
          });
        } else if (result.status === 401) {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  hideModal() {
    this.setState(
      {
        passwordPage: false,
        CPasswordValue: "",
        NPasswordValue: "",
        CNPasswordValue: "",
        FNameValue: "",
        MobileValue: "",
      },
      () => {
        this.props.hideModal();
      }
    );
  }

  // validateMobile(mobile) {
  //   const re =
  //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   return re.test(String(mobile).toLowerCase());
  // }

  saveProfile() {
    console.log(this.state.MobileValue);
    if (this.state.MobileValue !== null && this.state.MobileValue !== "") {
      if (!mobileRegex.test(this.state.MobileValue)) {
        toast.error("شماره همراه وارد شده نا معتبر است", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
        return;
      }
    }

    let data = {
      fullName: this.state.FNameValue,
      userMobile: this.state.MobileValue,
      businessCode: this.props.businessCode,
    };

    data = Object.assign(data, Authorization());

    this.setState({ buttonDisabled: true, saveLoading: true });
    console.log(data);
    fetch(BaseUrl + "editPersonalInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          toast.success("اطلاعات کاربری با موفقیت ذخیره شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ buttonDisabled: false, saveLoading: false }, () => {
            this.props.hideModal();
          });
        } else if (result.status === 401) {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        } else {
          this.setState({ buttonDisabled: false, saveLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ buttonDisabled: false, saveLoading: false });
      });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  cancelPassword() {
    this.setState({
      passwordPage: false,
      CPasswordValue: "",
      NPasswordValue: "",
      CNPasswordValue: "",
      CPasswordErrorText: "",
      NPasswordErrorText: "",
      CNPasswordErrorText: "",
      actionError: "",
    });
  }

  changePassword() {
    this.setState({
      passwordPage: true,
      CPasswordValue: "",
      NPasswordValue: "",
      CNPasswordValue: "",
      CPasswordErrorText: "",
      NPasswordErrorText: "",
      CNPasswordErrorText: "",
      actionError: "",
    });
  }

  changePasswordConfirm() {
    this.setState({ actionError: "" });

    let error = false;

    if (this.state.CPasswordValue === "") {
      this.setState({
        CPasswordErrorText: "لطفاً کلمه عبور فعلی را وارد کنید",
      });
      error = true;
    } else {
      this.setState({ CPasswordErrorText: "" });
    }

    if (this.state.NPasswordValue.length >= 8) {
      this.setState({ NPasswordErrorText: "" });
    } else {
      this.setState({
        NPasswordErrorText: "کلمه عبور باید حداقل 8 کاراکتر باشد",
      });
      error = true;
    }

    if (passRegex.test(this.state.NPasswordValue)) {
      this.setState({ NPasswordErrorText: "" });
    } else {
      this.setState({
        NPasswordErrorText:
          "کلمه عبور باید ترکیبی از حروف انگلیسی و اعداد باشد",
      });
      error = true;
    }

    if (this.state.CNPasswordValue === "") {
      this.setState({ CNPasswordErrorText: "کلمه عبور را تکرار کنید" });
      error = true;
    } else {
      this.setState({ CNPasswordErrorText: "" });
    }

    if (this.state.NPasswordValue === this.state.CNPasswordValue) {
      this.setState({ CNPasswordErrorText: "" });
    } else {
      this.setState({ CNPasswordErrorText: "کلمات عبور با هم متفاوت است" });
      error = true;
    }

    if (error) return;

    let data = {
      cpassword: this.state.CPasswordValue,
      npassword: this.state.CNPasswordValue,
      businessCode: this.props.businessCode,
    };
    data = Object.assign(data, Authorization());

    this.setState({ buttonDisabled: true, changePasswordLoading: true });

    fetch(BaseUrl + "changePassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          toast.success("کلمه عبور با موفقیت تغییر کرد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState(
            { buttonDisabled: false, changePasswordLoading: false },
            () => {
              this.props.hideModal();
            }
          );
        } else if (result.status === 401) {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        } else if (result.status === 402) {
          this.setState({
            actionError: "کلمه عبور فعلی اشتباه است",
            buttonDisabled: false,
            changePasswordLoading: false,
          });
        } else {
          this.setState({
            buttonDisabled: false,
            changePasswordLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ buttonDisabled: false, changePasswordLoading: false });
      });
  }

  render() {
    if (!this.state.loading) {
      if (!this.state.passwordPage) {
        return (
          <div className="profileContainer">
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <div className="fiObjectTitle" style={{ marginBottom: "20px" }}>
                اطلاعات کاربری
              </div>
              <Form.Control
                className="inputStyleForm inputCenter"
                style={{ marginBottom: "10px" }}
                placeholder="نام و نام خانوادگی"
                type="text"
                name="FNameValue"
                onChange={this.textHandleChange}
                value={this.state.FNameValue}
                disabled={this.state.buttonDisabled}
                ref={this.fnameInput}
              />

              <Form.Control
                className="inputStyleForm inputCenter"
                style={{ marginBottom: "10px", direction: "ltr" }}
                placeholder="تلفن همراه"
                type="text"
                name="MobileValue"
                onChange={this.textHandleChange}
                value={this.state.MobileValue}
                disabled={this.state.buttonDisabled}
              />

              <Form.Control
                className="inputStyleForm inputCenter"
                placeholder="نام کاربری"
                type="text"
                name="UserNameValue"
                value={this.state.UserNameValue}
                disabled={true}
              />
            </div>

            <div style={{ width: "100%" }}>
              <CustomButton
                title="تغییر کلمه عبور"
                imgHeight={30}
                imgWidth={30}
                minHeight="35px"
                img={Password}
                onClick={this.changePassword.bind(this)}
              />
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "0px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
              <div style={{ minWidth: "5px" }} />
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  loading={this.state.saveLoading}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.saveProfile.bind(this)}
                />
              </div>
            </div>
            {/* <div style={{width:'100%',marginTop:'5px'}}><CustomButton title="Close" backColor="var(--black1)" img={null} onClick={this.closeClick.bind(this)} /></div> */}
          </div>
        );
      } else {
        return (
          <div className="profileContainer">
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <div className="fiObjectTitle" style={{ marginBottom: "20px" }}>
                Change Password
              </div>
              <Form.Control
                className={
                  this.state.CPasswordErrorText === ""
                    ? "inputStyleForm inputCenter"
                    : "inputStyleForm inputCenter inputError"
                }
                // style={{marginBottom:'10px'}}
                placeholder="کلمه عبور فعلی"
                type="password"
                name="CPasswordValue"
                onChange={this.textHandleChange}
                value={this.state.CPasswordValue}
                disabled={this.state.buttonDisabled}
                ref={this.cpasswordInput}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px", padding: "0px 10px" }}
              >
                {this.state.CPasswordErrorText}
              </div>

              <Form.Control
                className={
                  this.state.NPasswordErrorText === ""
                    ? "inputStyleForm inputCenter"
                    : "inputStyleForm inputCenter inputError"
                }
                // style={{marginBottom:'10px'}}
                placeholder="کلمه عبور جدید"
                type="password"
                name="NPasswordValue"
                onChange={this.textHandleChange}
                value={this.state.NPasswordValue}
                disabled={this.state.buttonDisabled}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px", padding: "0px 10px" }}
              >
                {this.state.NPasswordErrorText}
              </div>

              <Form.Control
                className={
                  this.state.CNPasswordErrorText === ""
                    ? "inputStyleForm inputCenter"
                    : "inputStyleForm inputCenter inputError"
                }
                // style={{marginBottom:'10px'}}
                placeholder="تکرار کلمه عبور جدید"
                type="password"
                name="CNPasswordValue"
                onChange={this.textHandleChange}
                value={this.state.CNPasswordValue}
                disabled={this.state.buttonDisabled}
              />
              <div
                className="errorMessageContainer"
                style={{ marginBottom: "2px", padding: "0px 10px" }}
              >
                {this.state.CNPasswordErrorText}
              </div>
            </div>

            <div style={{ minHeight: "30px", width: "100%" }}>
              {this.state.actionError !== "" && (
                <div className="errorMessageContainerWithBG">
                  {this.state.actionError}
                </div>
              )}
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "0px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.cancelPassword.bind(this)}
                />
              </div>
              <div style={{ minWidth: "5px" }} />
              <div style={{ flex: "1.2" }}>
                <CustomButton
                  title="تغییر کلمه عبور"
                  fontSize={13}
                  loading={this.state.changePasswordLoading}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.changePasswordConfirm.bind(this)}
                />
              </div>
            </div>
            {/* <div style={{width:'100%',marginTop:'5px'}}><CustomButton title="Close" backColor="var(--black1)" img={null} onClick={this.closeClick.bind(this)} /></div> */}
          </div>
        );
      }
    } else {
      return (
        <div className="profileContainer" style={{ justifyContent: "center" }}>
          <WhisperSpinner
            size={50}
            color="var(--brown1)"
            frontColor="var(--brown1)"
            backColor="var(--brown1)"
            loading={true}
          />
        </div>
      );
    }
  }
}
